import React, { useState } from 'react';
import { Button } from '@rd-web-markets/shared/dist/util/buttons';
const DownloadCostTemplateButton = _ref => {
  let {
    generateCostTemplate,
    loading,
    withProjects = false
  } = _ref;
  return /*#__PURE__*/React.createElement(Button, {
    className: "mb-4",
    onClick: () => generateCostTemplate(),
    size: "md",
    loading: loading,
    variant: "info",
    iconPosition: "left",
    id: "download-template-button",
    icon: "download"
  }, withProjects ? 'Download Template With Projects' : 'Download Template');
};
export default DownloadCostTemplateButton;